<template>
  <div>
    <div class="parameters m-b-20 hidden">
      <div
        v-for="parameter in parameters"
        :key="parameter.name"
        class="parameter"
      >
        <ReportingMetricToggle
          :parameter="parameter"
          :total-value="parameter.totalValue"
          :selected="selectedParamsMap[parameter.name]"
          @click.native="handleOnParameterClick(parameter)"
        />
      </div>
    </div>

    <!-- This slot will contain the chart -->
    <slot />
  </div>
</template>

<script>
import { remove } from 'lodash';

import ReportingMetricToggle from '../ReportingMetricToggle';

export default {
  name: 'ReportingChartContainer',
  components: {
    ReportingMetricToggle,
  },
  props: {
    parameters: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedParameters: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    selectedParamsMap() {
      return this.selectedParameters.reduce((initialValue, parameter) => {
        initialValue[parameter.name] = true;

        return {...initialValue};
      }, {});
    }
  },
  methods: {
    handleOnParameterClick(parameter) {
      let selectedParametersCopy = [...this.selectedParameters];
      
      if (this.selectedParamsMap[parameter.name]) {
        remove(selectedParametersCopy, (p) => p.name === parameter.name);
      } else {
        selectedParametersCopy.push(parameter);
      }

      this.$emit('onChangeSelectedParameters', selectedParametersCopy);
    }
  },
};
</script>

<style lang="scss" scoped>
.parameters {
  display: flex;
  // flex-wrap: wrap;
  overflow: hidden;
}

.parameter {
  margin-bottom: 10px;
  align-items: stretch;

  &:not(:last-child) {
    margin-right: 20px;
  }
}
</style>